import { showAlert } from '../core/alerts.js';
import { showModal } from '../core/bootstrap-helpers.js';
import { isCompactChrome } from '../core/breakpoints.js';

var _popupQueue = [];
var _popupIsOpen = false;

export function respondNavbarForms() {
    var $navSearch = $('#nav-search').find('input[type="search"]');
    var $navSearchMobile = $('.js-search-box-mobile .ais-SearchBox-input');
    var $navAccount = $('.js-nav-account-wrap').find('input[type="text"].account-search');
    var windowWidth = $(window).width();

    if ($navSearch.length && $navAccount.length) {
        if (windowWidth <= 991) {
            $navSearch.attr('placeholder', 'Search');
            $navAccount.attr('placeholder', 'Account#');
        } else if (windowWidth <= 1740) {
            $navAccount.attr('placeholder', 'Account#');
        } else {
            $navSearch.attr(
                'placeholder',
                $navSearch.attr('data-original-placeholder')
            );
            $navAccount.attr('placeholder', 'Enter Account Number');
        }
    }

    // The compact box is on screen up to the mode boundary, not up to Bootstrap's `sm`.
    if ($navSearchMobile.length && $navAccount.length && isCompactChrome()) {
        $navSearchMobile.attr('placeholder', 'Search');
        $navAccount.attr('placeholder', 'Account#');
    }
}

export function initNavbarForms() {
    $('.dropdown-box').click(function (e) {
        e.stopPropagation();
    });

    $('.js-nav-account-wrap form').submit(function (e) {
        e.preventDefault();
        var $form = $(this);
        var link = $form.find('input[type="hidden"]').val();
        var account = $form.find('input[type="text"]').val();
        var win = window.open(link + '?au=' + account, '_blank');

        if (win) {
            win.focus();
        } else {
            showAlert({
                title: 'Please allow popups for this website.',
            });
        }
    });

    $('.mobile-collapsable-navbar .navbar-logo').click(function (e) {
        e.preventDefault();
        $(this).prev('.navbar-toggler').trigger('click');
    });
}

export function addPopupToQueue($modal, options) {
    _popupQueue.push({
        modal: $modal,
        options: options,
    });

    triggerNextPopup();
}

export function triggerNextPopup() {
    if (_popupIsOpen) {
        return false;
    }

    var popup = _popupQueue.shift();

    if (popup === undefined || !popup.hasOwnProperty('modal')) {
        return false;
    }

    if (popup.hasOwnProperty('options') && popup.options !== undefined) {
        showModal(popup.modal, popup.options);
    } else {
        showModal(popup.modal);
    }

    _popupIsOpen = true;

    popup.modal.on('hidden.bs.modal', function (e) {
        _popupIsOpen = false;
        triggerNextPopup();
    });
}
